import React from "react";

// import { Search } from "react-bootstrap-table2-toolkit";
import IconTooltip from "root/UI/Tooltip/IconTooltip";
import {Link} from "react-router-dom";

export const defaultSearchBarStyle = {
    height: "30px",
    width: "25vw",
    margin: "20px",
    paddingLeft: "7px",
    float: 'right',
    backgroundColor: "#edf4f9"
} ;

export const defaultTopLeftCellStyle = "5px 0px 0px 0px" ;
export const defaultTopRightCellStyle = "0px 5px 0px 0px" ;

export const defaultTableHeaderStyles = {
    backgroundColor: "#ECF6FD",
    textAlign: "left",
    border: "0",
    fontSize: "14px"
} ;

export const defaultChildTableHeaderStyles = {
    backgroundColor: "#10d954",
    textAlign: "left",
    border: "0",
    fontSize: "14px"
} ;

export const defaultPaginationOptions = {
    sizePerPage: 10,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    showTotal: true,
    className: "neil-pager"
};

export const defaultTableOptions = {
striped: true ,
bordered: false,
hover: true,
rowStyle: {
    color: "#605F5E",
    textAlign: "left",
    fontSize: "14px",
    margin: "10px"
}} ;

const defaultIconStyle = { marginLeft: '0px', marginRight: '0px', fontWeight: 'bold' } ;

const defaultIconStyleBootstrap = { marginLeft: '3px', marginRight: '0px', fontWeight: 'bold', fontSize: '18px' } ;

export const DEFAULT_ICON_MARGIN = '5px';

export const customHeaderStyle = (headerStyles, column, colIndex) => {

    const name = column.dataField ;

    let style = headerStyles.default ;

    if ( headerStyles[name] !== undefined )
    {
        style = { ...style, ...headerStyles[name]} ;
    }

    return style ;
};

export const TableActionIconGeneric = ( props ) =>
{
    const color = props.color === undefined ? "var(--s360-icon-blue)" : props.color ;
    const style = props.style === undefined ? defaultIconStyle : { ...defaultIconStyle,  ...props.style } ;

    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={style} placement='top' text={props.text} icon={props.icon} color={color}/>
    }
    else if ( props.to !== undefined && props.to !== null )
    {
        return <Link to={props.to}><IconTooltip placement='top' text={props.text} style={style} icon={props.icon} color={color}/></Link>
    }
    else if ( props.href !== undefined )
    {
        const href = props.href === undefined || props.href === null ? '#' : props.href ;
        const target = props.target === undefined || props.target === null ? '_blank' : props.target;

        return  <a href={href} target={target}><IconTooltip placement='top' text={props.text} style={style} icon={props.icon} color={color}/></a>
    }
    else
    {
        return <IconTooltip style={style} placement='top' text={props.text} icon={props.icon} color={color}/>
    }
}

export const TableActionIconGenericBootstrap = ( props ) =>
{
    const color = props.color === undefined ? "var(--s360-icon-blue)" : props.color ;
    const style = props.style === undefined ? defaultIconStyleBootstrap : { ...defaultIconStyleBootstrap,  ...props.style } ;

    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={style} placement='top' text={props.text} icon={props.icon} color={color}/>
    }
    else if ( props.to !== undefined && props.to !== null )
    {
        return <Link to={props.to}><IconTooltip placement='top' text={props.text} style={style} icon={props.icon} color={color}/></Link>
    }
    else if ( props.href !== undefined )
    {
        const href = props.href === undefined || props.href === null ? '#' : props.href ;
        const target = props.target === undefined || props.target === null ? '_blank' : props.target;

        return  <a href={href} target={target}><IconTooltip placement='top' text={props.text} style={style} icon={props.icon} color={color}/></a>
    }
    else
    {
        return <IconTooltip style={style} placement='top' text={props.text} icon={props.icon} color={color} type='bootstrap'/>
    }
}

export const TableActionIconEdit = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: DEFAULT_ICON_MARGIN}}
                            placement='top' text={props.text} icon="icon-edit" color="var(--s360-icon-blue)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={url} style={{marginRight: DEFAULT_ICON_MARGIN}}><IconTooltip placement='top' text={props.text}
                                                                                           icon="icon-edit"
                                                                                           color="var(--s360-icon-blue)"/></Link>
        }
    }
}

export const TableActionIconReply = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: DEFAULT_ICON_MARGIN}}
                            placement='top' text={props.text} icon="icon-reply" color="var(--s360-icon-blue)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={url} style={{marginRight: DEFAULT_ICON_MARGIN}}><IconTooltip placement='top' text={props.text}
                                                                                           icon="icon-reply"
                                                                                           color="var(--s360-icon-blue)"/></Link>
        }
    }
}

export const TableActionIconView = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: DEFAULT_ICON_MARGIN}}
                            placement='top' text={props.text} icon="icon-view" color="var(--s360-icon-blue)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={props.to} style={{marginRight: DEFAULT_ICON_MARGIN}}><IconTooltip placement='top' text={props.text}
                                                                                                icon="icon-components"
                                                                                                color="var(--s360-icon-blue)"/></Link>
        }
    }
}

export const TableActionIconManage = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: DEFAULT_ICON_MARGIN}}
                            placement='top' text={props.text} icon="icon-exclamation" color="var(--wieldy-nav-highlight-orange)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={props.to} style={{marginRight: DEFAULT_ICON_MARGIN}}><IconTooltip placement='top' text={props.text}
                                                                                                icon="icon-components"
                                                                                                color="var(--s360-icon-blue)"/></Link>
        }
    }
}

export const TableActionIconDelete = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: DEFAULT_ICON_MARGIN}}
                            placement='top' text={props.text} icon="icon-trash" color="var(--s360-icon-red)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={props.to} style={{marginRight: DEFAULT_ICON_MARGIN}}><IconTooltip placement='top' text={props.text}
                                                                                                icon="icon-trash"
                                                                                                color="var(--s360-icon-red)"/></Link>
        }
    }
}

export const TableActionIconChart = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: DEFAULT_ICON_MARGIN}}
                            placement='top' text={props.text} icon="icon-chart" color="var(--s360-icon-pink)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={props.to} style={{marginRight: DEFAULT_ICON_MARGIN}}><IconTooltip placement='top' text={props.text}
                                                                                                icon="icon-chart"
                                                                                                color="var(--s360-icon-pink)"/></Link>
        }
    }
}

export const TableActionIconPassword = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: DEFAULT_ICON_MARGIN}}
                            placement='top' text={props.text} icon="icon-reset-password" color="var(--s360-icon-blue)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={props.to} style={{marginRight: DEFAULT_ICON_MARGIN}}><IconTooltip placement='top' text={props.text}
                                                                                                icon="icon-reset-password"
                                                                                                color="var(--s360-icon-blue)"/></Link>
        }
    }
}

export const TableActionIconEmail = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: DEFAULT_ICON_MARGIN}}
                            placement='top' text={props.text} icon="icon-email" color="var(--s360-icon-blue)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={props.to} style={{marginRight: DEFAULT_ICON_MARGIN}}><IconTooltip placement='top' text={props.text}
                                                                                                icon="icon-email"
                                                                                                color="var(--s360-icon-blue)"/></Link>
        }
    }
}

export const TableActionIconAdd = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: DEFAULT_ICON_MARGIN}}
                            placement='top' text={props.text} icon="icon-add" color="var(--s360-icon-green)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={props.to} style={{marginRight: DEFAULT_ICON_MARGIN}}><IconTooltip placement='top' text={props.text}
                                                                                                icon="icon-add"
                                                                                                color="var(--s360-icon-green)"/></Link>
        }
    }
}

export const TableActionIconLink = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: DEFAULT_ICON_MARGIN}}
                            placement='top' text={props.text} icon="icon-signup" />
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={props.to} style={{marginRight: DEFAULT_ICON_MARGIN}}><IconTooltip placement='top' text={props.text} icon="icon-link"/></Link>
        }
    }
}

export const TableActionIconSuspend = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: DEFAULT_ICON_MARGIN}}
                            placement='top' text={props.text} icon="icon-thumbs-down" color="var(--s360-icon-red)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={props.to} style={{marginRight: DEFAULT_ICON_MARGIN}}><IconTooltip placement='top' text={props.text} icon="icon-thumbs-down" color="var(--s360-icon-red)"/></Link>
        }
    }
}

export const TableActionIconActivate = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: DEFAULT_ICON_MARGIN}}
                            placement='top' text={props.text} icon="icon-thumb-up" color="var(--s360-icon-green)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={props.to} style={{marginRight: DEFAULT_ICON_MARGIN}}><IconTooltip placement='top' text={props.text} icon="icon-thumb-up" color="var(--s360-icon-green)"/></Link>
        }
    }
}

export const TableActionIconAlert = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: DEFAULT_ICON_MARGIN}}
                            placement='top' text={props.text} icon="icon-exclamation" color="var(--s360-icon-red)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={props.to} style={{marginRight: DEFAULT_ICON_MARGIN}}><IconTooltip placement='top' text={props.text} icon="icon-exclamation" color="var(--s360-icon-red)"/></Link>
        }
    }
}